import { Text, ITextProps, TextSize, TextColor } from "./Text";

export type { ITextProps, TextSize, TextColor };
export default Text;
